/* eslint-disable @typescript-eslint/no-explicit-any */
import { type Parser, useQueryStates } from 'nuqs';
import { FilterDef } from '../Filters/types';

export function useQueryFilters<
  Defs extends readonly FilterDef<string, Parser<any>>[],
>(filtersConfig: {
  defs: Defs;
  parsers: {
    [K in Defs[number] as K['key']]: K['parser'];
  };
}) {
  const [filters, setFilters] = useQueryStates(filtersConfig.parsers);

  return { filters, setFilters };
}
